import { setViewAsAdmin } from "./viewAsAdmin";

export const clearAuthTokens = () => {
  localStorage.removeItem("token"); // Clear the authentication token
  localStorage.removeItem("admin-token"); // Clear the authentication token
  setViewAsAdmin(false);
};
